module.exports = __webpack_public_path__ + "media/images/flags/16/Madagascar-081d275b5394e840dc63145d0347a727.png";